<template>
  <div class="ai item">
    <div :class="[ landscape ? 'top' : 'top-portrait']">
      <div class="lf">
        <img class="logo" src="../../assets/ai/logo.png" v-animate-css="logoIn"  alt="">
        <img class="text" src="../../assets/ai/text.png" v-animate-css="textIn" alt="">
        <img class="bg" src="../../assets/ai/bg.png" v-animate-css="bgIn" alt="">
      </div>
      <div class="rt">
        <img class="en" src="../../assets/ai/en.png" alt="" v-animate-css="detailTextIn">
        <div class="line" v-animate-css="lineIn"></div>
        <p v-animate-css="detailText1In">人工智能技术将改变多个行业，越来越多的公司利用人工智能技术提高生产效率和质量。人工智能行业的工程技术的快速发展带来了模型训练、评价工具、硬件计算能力的巨大需求。</p>
        <p v-animate-css="detailText2In">我们将结合软件开发及人工智能开发的经验，与人工智能技术研究、开发的团队和公司一起，为本地企业提供方便易用的人工智能工程工具，并且为利用人工智能的公司提供相关的技术咨询及指导，助力传统企业把人工智能技术转化成生产力。</p>
        <p v-animate-css="detailText3In">同时，我们将提供模型训练、科研计算等领域的硬件计算能力租赁服务，这个服务将大大降低一些初创企业和团队利用人工智能的投入成本，也为学习人工智能的学生和开发者提供方便实惠的算力租赁服务。</p>
      </div>
    </div>
    <div class="paging">
      <div class="btn-right" @mouseover="showArrow('right')" @mouseout="hideArrow('right')" @click="slide(1)"></div>
      <div class="paging-left" v-if="left"></div>
      <div class="paging-right" v-if="right"></div>
      <div class="page-num">1/3</div>
    </div>
    <div class="close" @click="routeTo('Dashboard')">
      <div class="btn-close"></div>
      <span>close</span>
    </div>
  </div>
</template>

<script>
import Config from './Config.js'
export default {
  mixins: [
    Config
  ]
}
</script>

<style lang="scss" scoped>
@import '../../Global.scss';
@import './Detail.scss';
.logo {
  width: 1.18rem;
  height: 1.44rem;
  left: 1.25rem;
  top: 2rem;
}
.bg {
  width: 5.14rem;
  height: 4.06rem;
  left: 0;
}
.text {
  width: 1.8rem;
  height: 2.435rem;
  top: 1.45rem;
  left: 1.95rem;
}
.en {
  width: 1.67rem;
  height: .185rem;
  display: block;
}
.paging {
  background-image: url('../../assets/ai/paging.png');
  .btn-right {
    width: 1.4rem;
  }
  .page-num {
    left: .94rem;
  }
  .paging-left {
    background-image: url('../../assets/ai/paging_l.png');
  }
  .paging-right {
    background-image: url('../../assets/ai/paging_r.png');
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Detail/Part1.vue